import clsx from 'clsx'
import React, { useRef, useState } from 'react'

import ChevroDownIcon from '../../assets/img/ico-chevro-down.svg?react'

interface AccordionProps {
    header: React.ReactNode
    children: React.ReactNode
    defaultOpen?: boolean
}

const Accordion: React.FC<AccordionProps> = ({
    header,
    children,
    defaultOpen = false,
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen)
    const contentRef = useRef<HTMLDivElement | null>(null)

    const toggleAccordion = () => {
        setIsOpen(!isOpen)
    }

    return (
        <div
            className={clsx('accordeon', { 'active-accordeon': isOpen })}
            data-accordeon
        >
            <div className="accordeon-header">
                <div className="a-h-item">
                    <div className="a-h-item--sm">
                        <button
                            type="button"
                            className="btn btn-tool"
                            data-accordeon-btn
                            onClick={toggleAccordion}
                        >
                            <span
                                className={clsx('ico ico-rotate-accordeon', {
                                    open: isOpen,
                                })}
                            >
                                <ChevroDownIcon />
                            </span>
                        </button>
                    </div>
                </div>
                <div className="flex-auto">{header}</div>
            </div>
            <div
                className="calendar-body"
                style={{
                    maxHeight: isOpen
                        ? `${contentRef.current?.scrollHeight || 1000}px`
                        : '0',
                    transition: 'max-height 0.3s ease-out',
                    overflow: 'hidden',
                }}
            >
                {children}
            </div>
        </div>
    )
}

export default Accordion
